<template>
  <div class="form-group">
    <div :class="hasIcon(icon) || (type === 'password' ? 'input-group' : '')">
      <!-- Ícono a la izquierda -->
      <span v-if="iconDir === 'left'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>

      <!-- Campo de entrada -->
      <input
        :type="visiblePassword ? 'text' : type"
        class="form-control"
        :class="getClasses(size, null)"
        :name="name"
        :id="id"
        :placeholder="placeholder"
        :required="isRequired"
        :value="modelValue"
        :disabled="disabled"
        @input="$emit('update:modelValue', $event.target.value)"
      />

      <!-- Ícono para mostrar/ocultar contraseña -->
      <span
        v-if="type === 'password'"
        class="input-group-text cursor-pointer"
        @click="togglePasswordVisibility"
      >
        <i :class="visiblePassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
      </span>

      <!-- Ícono a la derecha -->
      <span v-if="iconDir === 'right'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "argon-input",
  props: {
    size: {
      type: String,
      default: "default"
    },
    valid: {
      type: Boolean,
      default: false
    },
    icon: String,
    iconDir: String,
    name: String,
    id: String,
    modelValue: String,
    placeholder: String,
    type: String,
    isRequired: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      visiblePassword: false
    };
  },
  methods: {
    getClasses(size, valid) {
      let sizeValue = size ? `form-control-${size}` : "";
      let isValidValue = typeof valid === "boolean" ? (valid ? "is-valid" : "is-invalid") : "";
      return `${sizeValue} ${isValidValue}`;
    },
    getIcon(icon) {
      return icon || "";
    },
    hasIcon(icon) {
      return icon ? "input-group" : "";
    },
    togglePasswordVisibility() {
      this.visiblePassword = !this.visiblePassword;
    }
  }
};
</script>
